var React = require('react');

function IconAssetFile (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M19.9066 7.5C19.7744 6.98265 19.5053 6.5053 19.1213 6.12132L15.8787 2.87868C15.4947 2.4947 15.0174 2.22556 14.5 2.09336V7.5H19.9066ZM20 9H14C13.4477 9 13 8.55229 13 8V2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V9Z","fill":"currentColor"}));
}

IconAssetFile.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor"};

module.exports = IconAssetFile;

IconAssetFile.default = IconAssetFile;
